import { DecisionDetail } from "../../../models/home";
import { buildAction, buildConfidence, buildPriority, buildRisk, isoFromNow } from "./home-qa-harness.builders";

export const FORM_DETAIL: DecisionDetail = {
  decision: {
    decisionId: "detail-form",
    state: "act_now",
    title: "Assign renewal owner before legal review",
    shortReason: "The decision is ready, but it must be handed off to a specific owner with an explicit reason.",
    documents: [
      {
        documentId: "doc-detail-form",
        classificationId: "class-detail-form",
        title: "Renewal assignment packet"
      }
    ],
    nextBestAction: buildAction("assign", "Assign owner", true, {
      description: "Choose the assignee and document why the handoff is required.",
      completionCriteria: ["Select owner", "Describe the handoff", "Confirm the reassignment"],
      requiresInput: true,
      executionMode: "detail",
      inputSchema: {
        type: "object",
        required: ["assignedToUserId", "reason"],
        properties: {
          assignedToUserId: {
            type: "select",
            label: "Owner",
            options: [
              { value: "u-4", label: "Legal Ops" },
              { value: "u-7", label: "Revenue Counsel" }
            ]
          },
          reason: {
            type: "textarea",
            label: "Reason",
            helperText: "Explain why this decision is being reassigned."
          },
          notes: {
            type: "textarea",
            label: "Notes",
            helperText: "Optional context for the assignee."
          }
        }
      }
    }),
    availableActions: [
      buildAction("assign", "Assign owner", true, {
        placement: "primary",
        requiresInput: true,
        executionMode: "detail",
        description: "Choose the assignee and document why the handoff is required.",
        completionCriteria: ["Select owner", "Describe the handoff", "Confirm the reassignment"],
        inputSchema: {
          type: "object",
          required: ["assignedToUserId", "reason"],
          properties: {
            assignedToUserId: {
              type: "select",
              label: "Owner",
              options: [
                { value: "u-4", label: "Legal Ops" },
                { value: "u-7", label: "Revenue Counsel" }
              ]
            },
            reason: {
              type: "textarea",
              label: "Reason",
              helperText: "Explain why this decision is being reassigned."
            },
            notes: {
              type: "textarea",
              label: "Notes",
              helperText: "Optional context for the assignee."
            }
          }
        }
      })
    ],
    priority: buildPriority(84, "high", "The owner must confirm the legal path before the SLA closes."),
    risk: buildRisk("medium", "An unassigned decision may stall the renewal path."),
    confidence: buildConfidence(0.9),
    evidence: [
      {
        evidenceId: "evidence-form-1",
        type: "assignment",
        label: "Current routing",
        value: "Needs legal owner confirmation before execution.",
        confidence: 0.91,
        source: "handoff-policy",
        occurredAt: isoFromNow(-2)
      }
    ],
    missingInformation: [],
    owner: { userId: "u-4", displayName: "Legal Ops" },
    dueAt: isoFromNow(18),
    updatedAt: isoFromNow(-1),
    traceId: "detail-form-trace",
    sourceTrace: {
      traceId: "detail-form-trace",
      actionSource: "policy-engine",
      confidenceSource: "handoff-router",
      explanationSource: "assignment-policy",
      evaluatorVersion: "2026.05.10",
      rulesVersion: "home-ia-v3"
    }
  },
  activityPreview: [
    {
      eventId: "activity-form-1",
      decisionId: "detail-form",
      documentIds: ["doc-detail-form"],
      type: "decision.updated",
      title: "Assignment requested",
      narrative: "The decision now needs a named owner before legal review can continue.",
      occurredAt: isoFromNow(-2)
    }
  ],
  relatedDecisionIds: ["detail-low-confidence"]
};
